
import { Component, Ref, Vue } from 'vue-property-decorator'
import ProofreadProblems from '@/components/templates/manage/ProofreadProblems.vue'
import { LearningProgress } from '@/const/LearningProgress'
import { ProofreadProblem } from '@/models/manage/ProofreadList'
import { CurriculumUnitsApi } from '@/api/methods/CurriculumUnitsApi'
import { CurriculumUnitsApi as ProofreadCurriculumUnitsApi } from '@/api/methods/proofread/CurriculumUnitsApi'

/**
 * 校正画面-問題一覧画面(知識マップ)
 */
@Component({
  components: {
    ProofreadProblems,
  },
})
export default class AcademyLearningMapProblems extends Vue {
  /** テンプレート情報 */
  @Ref()
  private proofreadProblems!: ProofreadProblems

  /** 読み込み完了フラグ */
  private isLoaded = false

  /** 単元名 */
  private unitName!: string

  /** 教科コード */
  private subjectCode!: string

  /** 問題一覧 */
  private problemList: ProofreadProblem[] = []

  /**
   * 単元ID
   *
   * @returns パスから取得した単元ID
   */
  private get curriculumUnitId(): number {
    return Number(this.$route.params.curriculumUnitId)
  }

  /**
   * 初期処理
   */
  private async mounted(): Promise<void> {
    this.$loading.start()

    // 問題一覧取得
    const problems = await ProofreadCurriculumUnitsApi.getCurriculumUnitProblems(this.curriculumUnitId)
    this.problemList = problems.map((problem) => {
      const progress = LearningProgress.findByLevel(problem.level)
      return {
        id: problem.id,
        code: problem.code,
        level: progress.labelFull,
      }
    })

    // 単元情報取得
    const curriculumUnit = await CurriculumUnitsApi.getCurriculumUnit(this.curriculumUnitId)
    this.unitName = curriculumUnit.name
    this.subjectCode = curriculumUnit.subjectCode

    this.isLoaded = true

    this.$loading.complete()
  }

  /**
   * 問題選択時の処理
   *
   * @param id 問題ID
   */
  private async eventSelectProblem(id: number): Promise<void> {
    await this.$router.push(`/academy/map/${this.curriculumUnitId}/${id}`)
  }

  /**
   * 単元選択画面への遷移処理
   */
  private async eventReturn(): Promise<void> {
    await this.$router.push({
      path: '/academy/map',
      query: {
        subject: this.subjectCode,
      },
    })
  }
}
